const dat = [
    {
        "srcImg": require('./asset/ajay.jpg'),
        "imgSrcAlt": "Ajay Antil",
        "desig": "CEO",
        "empname": "Ajay Antil",
        "linkedInLink": "https://www.linkedin.com/in/ajay-antil-b9998a251/"
    },
    {
        "srcImg": require('./asset/sumit.jpg'),
        "imgSrcAlt": "Sumit Sangale",
        "empname": "Sumit Sangale",
        "desig": "CEO",
        "linkedInLink": "https://www.linkedin.com/in/sumit-sangale-420bb4283/"
    },
    {
        "srcImg": require('./asset/parth.jpg'),
        "imgSrcAlt": "Parth Bandwal",
        "linkedInLink": "https://www.linkedin.com/in/parth-bandwal-962675281/",
        "empname": "Parth Bandwal",
        "desig": "CEO"
    },
    {
        "srcImg": require('./asset/lakshya.jpg'),
        "imgSrcAlt": "Lakshya Prajapati",
        "linkedInLink": "https://www.linkedin.com/in/lakshya-prajapati-877b22289/",
        "empname": "Lakshya Prajapati",
        "desig": "CEO"
    },
    {
        "srcImg": require('./asset/anurag.jpg'),
        "imgSrcAlt": "Anurag Yadav",
        "linkedInLink": "https://www.linkedin.com/in/anurag-iiitl/",
        "empname": "Anurag Yadav",
        "desig": "CEO"
    },
    {
        "srcImg": require('./asset/img.jpg'),
        "imgSrcAlt": "Sakshi Sahu",
        "linkedInLink": "https://www.linkedin.com/in/sakshi-sahu-97425b287/",
        "empname": "Sakshi Sahu",
        "desig": "CEO"
    },
    {
        "srcImg": require('./asset/img.jpg'),
        "imgSrcAlt": "Arshiya",
        "linkedInLink": "https://www.linkedin.com/in/arshia-adhya/",
        "empname": "Arshiya Adhya",
        "desig": "CEO"
    },
    {
        "srcImg": require('./asset/img.jpg'),
        "imgSrcAlt": "Radhika",
        "linkedInLink": "https://www.linkedin.com/in/radhika-kalanee-322161247/",
        "empname": "Radhika Kalanee",
        "desig": "CEO"
    }
];

export default dat;

